var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86383 13.1971C6.15672 12.9042 6.15672 12.4293 5.86383 12.1364L4.39416 10.6667L5.86383 9.19708C6.15672 8.90419 6.15672 8.42931 5.86383 8.13642C5.57093 7.84352 5.09606 7.84352 4.80317 8.13642L2.80317 10.1364C2.51027 10.4293 2.51027 10.9042 2.80317 11.1971L4.80317 13.1971C5.09606 13.49 5.57093 13.49 5.86383 13.1971Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5835 10.6667C2.5835 11.081 2.91928 11.4167 3.3335 11.4167L9.3335 11.4167C11.8943 11.4167 14.0835 9.49974 14.0835 7.00008C14.0835 4.50043 11.8943 2.58342 9.3335 2.58342L4.00016 2.58341C3.58595 2.58341 3.25016 2.9192 3.25016 3.33341C3.25016 3.74763 3.58595 4.08341 4.00016 4.08341L9.3335 4.08342C11.1914 4.08342 12.5835 5.44907 12.5835 7.00008C12.5835 8.55109 11.1914 9.91675 9.3335 9.91675L3.3335 9.91675C2.91928 9.91675 2.5835 10.2525 2.5835 10.6667Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowReturn);
export default __webpack_public_path__ + "static/media/icon-arrow-return.178d0515642367c28dcd82177faa61f0.svg";
export { ForwardRef as ReactComponent };